import { createBrowserRouter, Navigate } from "react-router-dom";
import LoginForm from "./components/LoginForm/LoginForm";
import Home from "./pages/Home/Home";
import Layout from "./layouts/Layout/Layout";
import { getToken } from "./helpers/getToken";
import { useContext } from "react";
import { AuthContext } from "./context/authContext";
import CalendarPage from "./pages/CalendarPage";
import AsanaTimeTrackingPage from "./pages/AsanaTimeTrackingPage";
import WorkingIntervals from "./pages/WorkingIntervals/WorkingIntervals";
import UserPage from "./pages/UserPage";
import CalendarPageV2 from "./pages/CalendarPageV2";

export function router() {
  const ProtectedRoute = ({ children }) => {
    const { currentUser } = useContext(AuthContext);

    if (!getToken() || currentUser === false) {
      return <Navigate to="/login" />;
    }

    return children;
  };

  return createBrowserRouter([
    {
      path: "/",
      errorElement: "Not found!",
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/calendar_v1",
          element: <CalendarPage />,
          errorElement: "Calendar",
        },
        {
          path: "/calendar",
          element: <CalendarPageV2 />,
          errorElement: "Calendar",
        },
        {
          path: "/asana-time-tracking",
          element: <AsanaTimeTrackingPage />,
          errorElement: "Not found!",
        },
        {
          path: "/working-intervals",
          element: <WorkingIntervals />,
          errorElement: "Not found!",
        },
        {
          path: "/user",
          element: <UserPage />,
          errorElement: "Not found!",
        },
      ],
    },
    {
      path: "/login",
      element: <LoginForm />,
      errorElement: "Not found!",
    },
  ]);
}
